import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["presence-validator", "checkbox-validator", "email-validator", "german-iban-validator"]
  static targets = ["page", "submit", "next", "previous", "progressBar", "pageOverlay"]
  static values = { pages: Number, startIndex: Number }

  connect() {
    // Initialize the form to show the first step or the specified start index
    this.showCurrentStep(0)
    this.addKeyPressListeners() // Add key press listeners to inputs
  }

  showCurrentStep(index) {
    this.currentPageIndex = index
    this.pageTargets.forEach((element, idx) => {
      element.hidden = idx !== this.currentPageIndex
    })
    this.checkSubmitButton()
    this.checkPreviousButton()
    this.checkNextButton()
    if (this.hasProgressBarTarget) {
      this.updateProgressBar()
    }
    this.trackStepView()
  }

  nextStepWithScrollUp() {
    if (this.validateCurrentStep()) {
      this.trackClickNext()
      this.scrollToTop()
      this.showCurrentStep(this.currentPageIndex + 1)
    }
  }

  nextStep() {
    if (this.validateCurrentStep()) {
      this.trackClickNext()
      this.showCurrentStep(this.currentPageIndex + 1)

    }
  }

  previousStep() {
    this.trackClickBack()
    this.showCurrentStep(this.currentPageIndex - 1)
  }

  clickSubmit(event) {
    event.preventDefault() // Prevent the default form submit on Enter
    if (this.validateCurrentStep()) {
      this.submitForm()
    }
  }

  validateCurrentStep() {
    const inputs = this.pageTargets[this.currentPageIndex].querySelectorAll(
      "input, select, div"
    )
    let isValid = true
    inputs.forEach((input) => {
      if (input.dataset.controller) {
        // If the input has a specific Stimulus controller for validation, trigger it.
        const controller = this.application.getControllerForElementAndIdentifier(
          input,
          input.dataset.controller
        )
        if (controller && controller.blur ) {
          const result = controller.blur() // Ensure your custom controllers have a validate method.
          if (!result) {
            isValid = false
          }
        }
        if (controller && controller.change) {
          const result = controller.change() // Ensure your custom controllers have a validate method.
          if (!result) {
            isValid = false
          }
        }
      }
      Array.from(inputs).forEach((input) => {
        if (input.checkValidity && input.checkValidity() === false) {
          isValid = false
        }
      })
    })
    this.presenceValidatorOutlets.forEach((validator) => {
      const pageNumber = validator.element.closest('.page')
      if (pageNumber !== null && 'page-' + (this.currentPageIndex + 1) === pageNumber.id) {
        const result = validator.blur()
        if (!result) {
          pageNumber.scrollIntoView()
          isValid = false
        }
      }
    })
    this.germanIbanValidatorOutlets.forEach((validator) => {
      const pageNumber = validator.element.closest('.page')
      if (pageNumber !== null && 'page-' + (this.currentPageIndex + 1) === pageNumber.id) {
        const result = validator.blur()
        if (!result) {
          pageNumber.scrollIntoView()
          isValid = false
        }
      }
    })
    this.checkboxValidatorOutlets.forEach((validator) => {
      const pageNumber = validator.element.closest('.page')
      if (pageNumber !== null && 'page-' + (this.currentPageIndex + 1) === pageNumber.id) {
        const result = validator.change()
        if (!result) {
          pageNumber.scrollIntoView()
          isValid = false
        }
      }
    })
    this.emailValidatorOutlets.forEach((validator) => {
      const pageNumber = validator.element.closest('.page')
      if (pageNumber !== null && 'page-' + (this.currentPageIndex + 1) === pageNumber.id) {
        const result = validator.blur()
        if (!result) {
          pageNumber.scrollIntoView()
          isValid = false
        }
      }
    })
    return isValid
  }

  checkSubmitButton() {
    Array.from(this.submitTargets).forEach((element) => {
      if (this.currentPageIndex !== this.pageTargets.length - 1) {
        element.hidden = true
        element.style.display = "none"
      } else {
        element.hidden = false
        element.style.display = "block"
      }
    })
  }

  checkPreviousButton() {

    Array.from(this.previousTargets).forEach((element) => {
      if (this.currentPageIndex === 0) {
        element.hidden = true
        element.style.display = "none"
      } else {
        element.hidden = false
        element.style.display = "block"
      }
    })
  }

  checkNextButton() {
    Array.from(this.nextTargets).forEach((element) => {
      if (this.currentPageIndex === this.pageTargets.length - 1) {
        element.style.display = "none"
        element.hidden = true;
      } else {
        element.hidden = false
        element.style.display = "block"
      }
    })
  }

  updateProgressBar() {
    const progressBarIndex = (this.hasStartIndexValue ? this.startIndexValue : 0) + this.currentPageIndex
    const totalSteps = (this.hasPagesValue ? this.pagesValue : this.pageTargets.length) * 1.0
    const progressPercentage = (progressBarIndex / totalSteps) * 100
    this.progressBarTarget.value = progressPercentage // Update the progress bar value
  }

  addKeyPressListeners() {
    const inputs = this.element.querySelectorAll("input, select")
    inputs.forEach((input) => {
      input.addEventListener("keypress", (event) => {
        if (event.key === "Enter") {
          event.preventDefault() // Prevent the default form submit on Enter
          this.handleEnterPress()
        }
      })
    })
  }

  handleEnterPress() {
    if (this.currentPageIndex < this.pageTargets.length - 1) {
      this.nextStep()
    } else {
      this.submitForm()
    }
  }

  submitForm() {
    if (this.validateCurrentStep()) {
      this.trackClickNext()
      if (this.hasPageOverlayTarget) {
        this.pageOverlayTarget.style.display = 'flex';
      }
      this.submitTargets.forEach((element) => {
        element.disabled = "disabled"
      })
      this.element.submit() // This assumes the form is valid
    }
  }

  trackStepView() {
    window.parent.postMessage({ type: 'track', action: 'page_view', step: this.totalStep() }, "https://fleming.de");
  }

  trackClickNext() {
    window.parent.postMessage({ type: 'track', action: 'click_next', step: this.totalStep() }, "https://fleming.de");
  }

  trackClickBack() {
    window.parent.postMessage({ type: 'track', action: 'click_back', step: this.totalStep() }, "https://fleming.de");
  }

  scrollToTop() {
    console.log('scrollToTheTop');
    window.parent.postMessage({ action: 'scrollToTop' }, "https://fleming.de");
  }

  totalStep() {
    return this.currentPageIndex + this.startIndexValue + 1
  }
}
